export const DEMO_CAMERA = "https://images.unsplash.com/photo-1759568558557-72e79f7c86e4?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200";
export const DEMO_SCENE = "https://images.unsplash.com/photo-1762979772530-81c3a60f5010?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200";

export const TEMPLATE_IMAGES = {
  dune: "https://images.unsplash.com/photo-1536772352522-6f715556f25f?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000",
  bladerunner: "https://images.unsplash.com/photo-1601042879364-f3947d3f9c16?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000",
  budapest: "https://images.unsplash.com/photo-1655933312296-4aa306640fb7?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000",
  godfather: "https://images.unsplash.com/photo-1634733049839-0292be607569?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000",
  revenant: "https://images.unsplash.com/photo-1748075039070-2c73013e0ee3?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000",
};
